<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <editor-qi :config="{id: gridConfig.id, api: 'QualityInspections/Get/'}"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'QIIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor-qi': () => import(/* webpackChunkName: 'QI' */ './Editor.vue')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
<style lang="stylus">
  @media screen and (min-width: 1280px) {
    .grid-side.grid_qi{
      .grid-wrapper{
        .grid-toolbar{
          width 100%
          .toolbar-filters{
            flex-wrap nowrap
            form, .toolbar-filters-control{
              display block
              min-width 15rem
              width 100%
            }
          }
          .qi-filter-field {
            min-width unset !important
            max-width 25 rem
          }
        }
      }
    }
  }
  @media screen and (max-width: 1280px) {
    .grid_qi{
      .grid-toolbar{
        .qi-filter-field {
          min-width 13rem
          width 13rem
        }
      }
    }
  }
</style>
